import { useState, useRef } from "react";
import emailjs from '@emailjs/browser';
import React from "react";
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap'

export const Contact = (props) => {
  const { t } = useTranslation();
  const form = useRef();
  const sender = useRef();
  const email = useRef();
  const message = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const serviceId = "service_qtkhw4c";
    const templateId = "template_ewf8x08";

    setIsLoading(true);

    emailjs
      .sendForm(serviceId, templateId, form.current, {
        publicKey: "aTx-_TifpWP419zft",
      })
      .then(
        () => {
          sender.current.value = "";
          email.current.value = "";
          message.current.value = "";      
          setIsLoading(false); 
        },
        (error) => {
          alert(t("Contact.error"))
          setIsLoading(false);
        },
      );  
  };

  return (
    <>
    { isLoading ?
      <div className="loading-modal">
        <img src="img/sending.gif" alt="Not found" className="loading-gif" />
        <span className="content-loading">
          {t("Contact.loadingMessage")}
        </span>
      </div> : 
      null         
      }    
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>{t("Contact.note")}</h2>
                <p>
                {t("Contact.text")}
                </p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit} ref={form}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        ref={sender}
                        id="name"
                        name="sender"
                        className="form-control"
                        placeholder="Name"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        ref={email}
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    ref={message}
                    className="form-control"
                    rows="4"
                    placeholder={t("Contact.message")}
                    required
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <div className="contact-actions">
                  <button type="submit" className="btn btn-secondary btn-lg">
                    {t("Contact.send")}
                  </button>
                  <a
                    href="https://calendly.com/consulting-kallideus/30min"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-secondary btn-lg"
                  >
                    {t("Contact.book")}
                  </a>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>{t("Contact.info")}</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> {t("Contact.addresslabel")}
                </span>
                {t("Contact.address")}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {t("Contact.email")}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={t("Contact.linkedin")} target="_blank" rel="noreferrer">
                      <i className="fa fa-linkedin-square"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container2 text-center">
          <Row>
            <Col xs={12} xl={4}>
              <a href="/impressum" style={{fontSize: "14px"}}>
                  Impressum
              </a>
            </Col>
            <Col xs={12} xl={4} style={{fontSize: "14px"}}>
              &copy; 2024 Kallideus | {" "}
              <span>
                Industrial Consulting & Development
              </span>
            </Col>
            <Col xs={12} xl={4}>
              <a href="https://www.freepik.com/" target="_blank"  rel="noreferrer" style={{fontSize: "14px"}}>
                  Some resources are Designed by Freepik
              </a>
            </Col>          
          </Row>
        </div>
      </div>
    </div>
    </>    
  );
};


//<div className="contact-item">
//<p>
//  <span>
//    <i className="fa fa-phone"></i> {t("Contact.phonelabel")}
//  </span>{" "}
//  {t("Contact.phone")}
//</p>
//</div>